import { FunnelFunctions } from 'features/co-pilot/co-pilot.types';
import { MessageTypes } from '../inbox/funnel-inbox.types';

export type Statistics = {
  dates: string[];
} & {
  [value in FunnelFunctions]?: number[];
};

export type StatisticsKeys = keyof Omit<Statistics, 'dates'>;

export interface Message {
  date: number;
  direction: MessageDirections;
  text: string;
  match?: number;
  step?: { functionName: FunnelFunctions; stepIndex: number };
  messageType?: MessageTypes;
}

export interface LinkedinContact {
  messages: Message[];
  name: string;
  linkedInURL?: string;
  sentiment?: string;
  reason?: string;
  profileIds?: { linkedin?: string; vanity?: string };
  funnelId?: string;
}

export enum MessageDirections {
  SENT = 'sent',
  RECEIVED = 'received',
}

export interface PerformanceOverview {
  sentConnectionRequestsCount: number;
  acceptedConnectionRequestsCount: number;
  avgConnectionRequestAcceptanceTime: number;
  contactedContactsCount: number;
  replyAndAcceptCount: number;
  messageReplyCount: number;
  positiveReplyCount: number;
  negativeReplyCount: number;
  avgLeadToConversionTime: number;
  hasConnectionRequests: boolean;
}

export interface FlowStatistics {
  functionNumber?: number;
  functionName: string;
  sentCount: number;
  repliedCount: number;
  avgTimeToConversion: number; // number in seconds
}

export interface DistributionMetrics {
  personalityTypes: { text: string; percentage: number }[];
  reasons: { text: string; percentage: number }[];
  profileViews: {
    viewedProfile: number;
    didNotViewProfile: number;
  };
  professionalProfiles: {
    industries: { text: string; percentage: number }[];
    companySizes: { text: string; percentage: number }[];
  };
}

export interface PerformanceDistribution {
  posReplies: DistributionMetrics;
  negReplies: DistributionMetrics;
}

export interface PerformanceComparison {
  funnelId: string;
  funnelName: string;
  linkedinAccountId?: string;
  linkedinAccountName?: string;
  sentConnectionRequestsCount: number;
  acceptedConnectionRequestsCount: number;
  avgConnectionRequestAcceptanceTime: number;
  contactedContactsCount: number;
  replyAndAcceptCount: number;
  messageReplyCount: number;
  positiveReplyCount: number;
  negativeReplyCount: number;
  avgLeadToConversionTime: number;
  hasConnectionRequests: boolean;
}

export const TimeFormatKeys = {
  WEEK: 'timeFormatWeek',
  WEEKS: 'timeFormatWeeks',
  DAY: 'timeFormatDay',
  DAYS: 'timeFormatDays',
  HOUR: 'timeFormatHour',
  HOURS: 'timeFormatHours',
  MINUTES: 'timeFormatMinutes',
  MINUTE: 'timeFormatMinute',
  NO_TIME: 'timeFormatNoTime',
};
